export default __webpack_public_path__ + "static/media/postgres.346709d9.png";